import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLayoutList = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-table-of-contents",
	transform: "scale(-1,1)",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(24, 0) scale(-1, 1)",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M8 12H21" }),
			/* @__PURE__ */ _jsx("path", { d: "M8 18H21" }),
			/* @__PURE__ */ _jsx("path", { d: "M8 6H21" }),
			/* @__PURE__ */ _jsx("path", { d: "M3 12h.01" }),
			/* @__PURE__ */ _jsx("path", { d: "M3 18h.01" }),
			/* @__PURE__ */ _jsx("path", { d: "M3 6h.01" })
		]
	})
});
export { SvgLayoutList as ReactComponent };
